module.exports = __webpack_public_path__ + "img/ring_g_c_0_0@2x.34439a8d.png";